import React, { memo } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';
// Local files
import ErrorWrapper from '../ErrorWrapper/ErrorWrapper';

const filter = createFilterOptions();

const FormAutocomplete = ({ symbol = null, label, placeholder, error, helperText, ...otherProps }) => {

  return (
    <Autocomplete
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        const isExisting = options.some((option) => inputValue === option);
        
        if (inputValue !== '' && !isExisting) {
          filtered.push(!!symbol ? symbol + inputValue : inputValue);
        }
        
        return filtered;
      }}
      renderInput={
        (params) => {
          const { InputLabelProps, InputProps, ...otherParams } = params;

          return (
            <TextField
              margin='normal'
              InputLabelProps={{
                ...InputLabelProps
              }}
              InputProps={{
                ...InputProps
              }}
              label={label}
              placeholder={placeholder}
              error={error}
              helperText={helperText}
              {...otherParams}
            />
          );
        }
      }
      {...otherProps}
    />
  );
};

FormAutocomplete.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    input: PropTypes.string.isRequired
  }),
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  freeSolo: PropTypes.bool,
  symbol: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  renderOption: PropTypes.func.isRequired
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FormAutocomplete {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);